import axios, { AxiosResponse } from 'axios'
import config from '@/config/config-esm'

import { setSignedIn, setSignedOut } from '@/store/slices/authenticateSlice'
import { setUser, unsetUser } from '@/store/slices/userSlice'
import { setHome } from '@/store/slices/layoutSlice'

interface User {
  // Add specific user properties based on your API response
  [key: string]: any
}

interface Role {
  // Add specific role properties based on your API response
  [key: string]: any
}

interface Department {
  // Add specific department properties based on your API response
  [key: string]: any
}

interface AuthResponse {
  success: boolean
  user: User
  roles: Role[]
  departments: Department[]
}

interface Store {
  dispatch: Dispatch
}

type Dispatch = (action: any) => void

const handleSignedIn = (dispatch: Dispatch, response: AxiosResponse<AuthResponse>): void => {
  dispatch(
    setUser({
      user: response.data.user,
      roles: response.data.roles,
      departments: response.data.departments,
    }),
  )
  dispatch(setSignedIn())
}

const handleSignedOut = (dispatch: Dispatch): void => {
  dispatch(setSignedOut())
  dispatch(unsetUser())
}

interface CheckLoginParams {
  store?: Store
  dispatch?: Dispatch
}

export const checkIfLoggedIn = ({ store, dispatch }: CheckLoginParams): void => {
  const dp = dispatch || store?.dispatch
  if (!dp) {
    console.error('No dispatch function available')
    return
  }

  const myStorage = window.localStorage
  const token = myStorage.getItem('token')
  
  if (token) {
    axios.defaults.headers.common['authorization'] = token
    axios
      .get<AuthResponse>(`${config.apiUrl}/authenticate`)
      .then((response) => {
        response.data.success ? handleSignedIn(dp, response) : handleSignedOut(dp)
      })
      .catch((error) => {
        handleSignedOut(dp)
        logOut(dp)
      })
  } else {
    handleSignedOut(dp)
  }
}

export const logOut = (dispatch: Dispatch): void => {
  const myStorage = window.localStorage
  delete axios.defaults.headers.common['authorization']
  myStorage.removeItem('token')
  dispatch(unsetUser())
  dispatch(setSignedOut())
  dispatch(setHome())
}